import KendoNumericTextBoxMixin from './KendoNumericTextBoxMixin'

export default {
    name: 'kendo-numerictextbox',
    mixins: [ KendoNumericTextBoxMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoNumericTextBox/index.js